(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["weekly-handbag-reveal"]) return;
  try {
    
(function () {
  console.log("[LM] IIFE start — initializing Weekly Handbag Reveal");

  const TOTAL_TILES = 16;
  console.log("[LM] TOTAL_TILES:", TOTAL_TILES);

  const root = document.getElementById("luxmyx-game-root");
  console.log("[LM] root element:", root);

  if (!root || !window.WEEKLY_REVEALS) {
    console.log("[LM] Abort: root or WEEKLY_REVEALS missing", { hasRoot: !!root, hasReveals: !!window.WEEKLY_REVEALS });
    return;
  }

  const overlay = root.querySelector("#grid-overlay");
  const status = root.querySelector("#status-message");
  const btnContainer = root.querySelector("#button-container");
  const targetImage = root.querySelector("#target-image");
  const shareButton = root.querySelector("#share-button");

  console.log("[LM] DOM refs:", { overlay, status, btnContainer, targetImage, shareButton });

  const weekdayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const today = weekdayNames[new Date().getDay()];
  console.log("[LM] Today:", today);

  const TODAY_REVEAL = window.WEEKLY_REVEALS[today];

  document.addEventListener("contextmenu", e => {
    e.preventDefault();
    console.log("[LM] Context menu prevented");
  });

  if (!TODAY_REVEAL) {
    console.log("[LM] Abort: no TODAY_REVEAL for day:", today);
    return;
  }

  const PROTECTED_TILE_INDEX = TODAY_REVEAL.lastTileIndex || 7;
  const REVEAL_DELAY = window.GAME_REVEAL_DELAY || 1500;

  console.log("[LM] TODAY_REVEAL:", TODAY_REVEAL);
  console.log("[LM] PROTECTED_TILE_INDEX:", PROTECTED_TILE_INDEX);
  console.log("[LM] REVEAL_DELAY:", REVEAL_DELAY);

  targetImage.src = TODAY_REVEAL.image;
  console.log("[LM] targetImage.src set:", targetImage.src);

  const OPTIONS = TODAY_REVEAL.options;
  const CORRECT_ANSWER = TODAY_REVEAL.correct;

  console.log("[LM] OPTIONS:", OPTIONS);
  console.log("[LM] CORRECT_ANSWER:", CORRECT_ANSWER);

  const RIGHT_ANSWER_DETAILS = {
    id: CORRECT_ANSWER,
    title: (OPTIONS.find(o => o.id === CORRECT_ANSWER) || OPTIONS[0]).label,
    baseUrl: TODAY_REVEAL.exploreUrl || ""
  };

  console.log("[LM] RIGHT_ANSWER_DETAILS:", RIGHT_ANSWER_DETAILS);

  let squares = [];
  let revealedIndices = new Set();
  let gameActive = true;
  let userHasGuessed = false;
  let userTag = "Beginner";
  let rewardPoints = 0;
  let finalUrlWithParams = null;
  let gameLoopId = null;
  let tileIndexAtGuess = null;

  console.log("[LM] Initial state:", {
    gameActive,
    userHasGuessed,
    userTag,
    rewardPoints,
    finalUrlWithParams,
    tileIndexAtGuess
  });

  function renderButtons() {
    console.log("[LM] renderButtons() called");
    const shuffled = [...OPTIONS].sort(() => Math.random() - 0.5);
    console.log("[LM] Shuffled options:", shuffled);

    btnContainer.innerHTML = "";

    shuffled.forEach((opt) => {
      const btn = document.createElement("button");
      btn.innerText = opt.label;
      btn.dataset.id = opt.id;
      console.log("[LM] Creating button for option:", opt);

      btn.onclick = () => {
        console.log("[LM] Button clicked — option id:", opt.id);
        handleGuess(opt.id);
      };

      btnContainer.appendChild(btn);
    });
  }

  function setupGrid() {
    console.log("[LM] setupGrid() called");
    overlay.innerHTML = "";
    squares = [];

    for (let i = 0; i < TOTAL_TILES; i++) {
      const div = document.createElement("div");
      div.className = "square";
      if (revealedIndices.has(i)) {
        div.classList.add("revealed");
      }
      overlay.appendChild(div);
      squares.push(div);
    }

    console.log("[LM] Grid initialized — squares length:", squares.length);
  }

  function revealAllTiles() {
    console.log("[LM] revealAllTiles() called");
    for (let i = 0; i < squares.length; i++) {
      if (!revealedIndices.has(i)) {
        revealedIndices.add(i);
        squares[i].classList.add("revealed");
        console.log("[LM] Tile revealed in revealAllTiles:", i);
      }
    }
    console.log("[LM] revealAllTiles() complete — revealedIndices size:", revealedIndices.size);
  }

  function computeUserTagAndPoints(isCorrect, tilesRevealedAtGuess) {
    console.log("[LM] computeUserTagAndPoints() called", { isCorrect, tilesRevealedAtGuess });

    if (!isCorrect) {
      rewardPoints = 0;
      userTag = "Beginner";
      console.log("[LM] User incorrect — reset to Beginner, rewardPoints:", rewardPoints);
      return;
    }

    rewardPoints = TOTAL_TILES - tilesRevealedAtGuess;
    const percent = (tilesRevealedAtGuess / TOTAL_TILES) * 100;

    if (percent < 25) userTag = "Master";
    else if (percent < 50) userTag = "Expert";
    else if (percent < 100) userTag = "Enthusiast";
    else if (percent > 100) userTag = "Good";
    else userTag = "Beginner";

    console.log("[LM] Tag + points computed:", { userTag, rewardPoints, percent });
  }

  function buildFinalUrl() {
    console.log("[LM] buildFinalUrl() called");
    const params = new URLSearchParams({
      tag: userTag,
      points: rewardPoints
    });
    finalUrlWithParams = RIGHT_ANSWER_DETAILS.baseUrl
      ? RIGHT_ANSWER_DETAILS.baseUrl + "?" + params.toString()
      : "";

    console.log("[LM] finalUrlWithParams:", finalUrlWithParams);
  }

  const TAG_MESSAGES = {
    Beginner: (check, title) => {
      console.log("[LM] TAG_MESSAGES.Beginner called", { check, title });
      return `${check} ${window.TAG_MESSAGES_CONFIG.Beginner.replace('{title}', '<strong>' + title + '</strong>')}`;
    },
    Master: (check, title) => {
      console.log("[LM] TAG_MESSAGES.Master called", { check, title });
      return `${check} ${window.TAG_MESSAGES_CONFIG.Master.replace('{title}', '<strong>' + title + '</strong>')}`;
    },
    Expert: (check, title) => {
      console.log("[LM] TAG_MESSAGES.Expert called", { check, title });
      return `${check} ${window.TAG_MESSAGES_CONFIG.Expert.replace('{title}', '<strong>' + title + '</strong>')}`;
    },
    Enthusiast: (check, title) => {
      console.log("[LM] TAG_MESSAGES.Enthusiast called", { check, title });
      return `${check} ${window.TAG_MESSAGES_CONFIG.Enthusiast.replace('{title}', '<strong>' + title + '</strong>')}`;
    },
    Good: (check, title) => {
      console.log("[LM] TAG_MESSAGES.Good called", { check, title });
      return `${check} ${window.TAG_MESSAGES_CONFIG.Good.replace('{title}', '<strong>' + title + '</strong>')}`;
    }
  };

  function renderAnswerDetails() {
    console.log("[LM] renderAnswerDetails() called", {
      userTag,
      rewardPoints,
      finalUrlWithParams,
      RIGHT_ANSWER_DETAILS
    });

    status.innerHTML = "";

    const wrapper = document.createElement("div");
    wrapper.className = "answer-details";

    const titleEl = document.createElement("div");
    titleEl.className = "answer-details-title";

    const check = `<span class="answer-checkmark">✓</span>`;
    console.log("[LM] Checkmark HTML:", check);

    const messageBuilder = TAG_MESSAGES[userTag];
    const message = messageBuilder(check, RIGHT_ANSWER_DETAILS.title);

    console.log("[LM] Final TAG message:", message);

    let exploreLinkHtml = "";
    if (RIGHT_ANSWER_DETAILS.baseUrl && RIGHT_ANSWER_DETAILS.baseUrl.length > 0) {
      exploreLinkHtml = `
      <a href="${finalUrlWithParams}" 
         target="_blank" 
         rel="noopener noreferrer" 
         class="answer-explore-link">
        Explore
      </a>
      `;
      console.log("[LM] Explore link HTML:", exploreLinkHtml);
    } else {
      console.log("[LM] No explore URL — explore link omitted");
    }

    titleEl.innerHTML = `${message} ${exploreLinkHtml}`;

    wrapper.appendChild(titleEl);
    status.appendChild(wrapper);

    console.log("[LM] Answer details rendered");
  }

 function markCorrectAnswerAfterTimeout() {
  console.log("[LM] markCorrectAnswerAfterTimeout() called");
  const correctBtn = btnContainer.querySelector(`button[data-id="${CORRECT_ANSWER}"]`);
  if (correctBtn) {
    correctBtn.classList.add("correct-answer-hint");
    console.log("[LM] correct-answer-hint added to correct button");
  } else {
    console.log("[LM] No correct button found in markCorrectAnswerAfterTimeout");
  }
}

// * GA4 Page view event for Game Played ---------------------------------------------------------
function sendGA4GamePageView(payload) {
  if (!window.gtag) {
    console.warn("[LM] GA4 not available");
    return;
  }

  const klaId3 = getKlaviyoId();
  // Fire a GA4 page_view event with Reveal Game data
  gtag("event", "Reveal Game Played", {
    page_title: "Reveal Game",
    klaviyo_id: klaId3,
    page_location: window.location.href,
    page_path: window.location.pathname,
    ...payload // attach all LM-* fields from the Klaviyo event
  });

  console.log("[LM] GA4 page_view event sent:", payload);
}


// * GA4 lead capture event for email + survey ------------------------------------------------
function sendGA4LeadEvent(formId, formData) {
  if (!window.gtag) {
    console.warn("[LM] GA4 not available");
    return;
  }
const klaId2 = getKlaviyoId();
  gtag("event", "LM Game lead", {
    lead_source: "klaviyo_popup",
    form_id: formId,
    klaviyo_id: klaId2,
    page_location: window.location.href,
    page_path: window.location.pathname,
    ...formData // includes email + all survey fields
  });

  console.log("[LM] GA4 lead event sent:", { formId, formData });
}

// * GA4 Page listener for email pop-up submission ---------------------------------------------------------
window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type !== "submit") return;

  const formId = e.detail.formId;
  const formData = e.detail.formData;

  // Fire GA4 lead event
  sendGA4LeadEvent(formId, formData);
});

// * GA4 ---------------------------------------------------------

function getKlaviyoId() {
  const match = document.cookie.match(/__kla_id=([^;]+)/);
  return match ? match[1] : null;
}

function setGA4UserId() {
  console.log("[LM] GA user id ..");
  const klaId = getKlaviyoId();
  if (!klaId || !window.gtag) return;

  gtag("set", { user_id: klaId });
  console.log("[LM] GA user id set:", klaId);
}
setGA4UserId();

/* ---------------------------------------------------------
   Minimal Klaviyo Event Push (App Embed Compatible)

   //2-step email capture only: WDwF6a
   //all steps dropdown: ThJRhF

   //all steps : radio - W6SEnG
   --------------------------------------------------------- */
 function fireKlaviyoEvent(payload) {
  //!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
  window._learnq = window._learnq || [];
  
  if (klaviyo ) {
    window._learnq.push(["track", "LM - Handbag Reveal Game Played", payload]);
    console.log("[LM] Klaviyo event pushed:", payload);
    sendGA4GamePageView(payload);
    
    
    //klaviyo.identify({}).then(() => console.log('Identify has been completed'));
    //try {
    // // Execution pauses here until the tracking request finishes
    //await klaviyo.track('LM - Handbag Reveal Game Played', payload);
    
    //// This line only runs AFTER the track call is successful
    //console.log('LM - Handbag Reveal Game Played Event tracked successfully!');
  //} catch (err) {
    //// This catches network errors or issues with the tracking call
    //console.error('LM - Handbag Reveal Game Played Tracking failed:', err);
  //}
    console.log("[LM] Opening Form A in 2 seconds… PAUSED");
    /*
    setTimeout(() => {
      console.log("[LM] Opening Form A now (W6SEnG)");
      window._klOnsite.push(['openForm', 'W6SEnG']);
    }, 3000);
    */

  } else {
    console.warn("[LM] Klaviyo not available — event skipped.");
  }
}

function klaviyoReady(callback) {
  const check = () => {
    if (window._learnq && typeof window._learnq.push === "function") {
      callback();
    } else {
      setTimeout(check, 50);
    }
  };
  check();
}

function buildKlaviyoPayload(isCorrect) {
  const pst = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

  return {
    "LM-GameDate": pst.toISOString().slice(0, 10),
    "LM-GameDateTime": pst.toISOString().replace("T", " ").slice(0, 19),
    "LM-DayOfWeek": pst.toLocaleString("en-US", { weekday: "long" }),
    "LM-CorrectAnswer": RIGHT_ANSWER_DETAILS.title,
    "LM-GuessedCorrectly": isCorrect,
    "LM-TileIndexAtGuess": tileIndexAtGuess,
    "LM-Tag": userTag,
    "LM-Points": rewardPoints,
    "LM-URL": window.location.href,
    "LM-Explore": RIGHT_ANSWER_DETAILS.baseUrl || ""
  };

}


function startGameLoop() {
  console.log("[LM] startGameLoop() called");
  gameLoopId = setInterval(() => {
    console.log("[LM] Game loop tick — current revealedIndices size:", revealedIndices.size);

    const remaining = squares
      .map((_, i) => i)
      .filter((i) => !revealedIndices.has(i));

    console.log("[LM] Remaining tiles:", remaining);

    // CASE A — No guess, only protected tile left
    if (!userHasGuessed && remaining.length === 1 && remaining[0] === PROTECTED_TILE_INDEX) {
      console.log("[LM] CASE A triggered — no guess, only protected tile left");
      clearInterval(gameLoopId);
      gameActive = false;

      revealedIndices.add(PROTECTED_TILE_INDEX);
      squares[PROTECTED_TILE_INDEX].classList.add("revealed");

      const correctBtn = btnContainer.querySelector(`button[data-id="${CORRECT_ANSWER}"]`);
      if (correctBtn) {
        correctBtn.classList.add("selected-correct", "correct-answer-hint", "correct-final");
      }

      computeUserTagAndPoints(false, revealedIndices.size);
      buildFinalUrl();
      renderAnswerDetails();

      // Fire Klaviyo event ONCE
      fireKlaviyoEvent(buildKlaviyoPayload(false));
      return;
    }

    // CASE B — User guessed, only protected tile left
    if (userHasGuessed && remaining.length === 1 && remaining[0] === PROTECTED_TILE_INDEX) {
      console.log("[LM] CASE B triggered — user guessed, only protected tile left");
      clearInterval(gameLoopId);
      gameActive = false;

      revealedIndices.add(PROTECTED_TILE_INDEX);
      squares[PROTECTED_TILE_INDEX].classList.add("revealed");

      const correctBtn = btnContainer.querySelector(`button[data-id="${CORRECT_ANSWER}"]`);
      if (correctBtn) {
        correctBtn.classList.add("selected-correct", "correct-answer-hint", "correct-final");
      }

      renderAnswerDetails();

      // Fire Klaviyo event ONCE
      //fireKlaviyoEvent(buildKlaviyoPayload(true));
      klaviyoReady(() => {
      fireKlaviyoEvent(buildKlaviyoPayload(true));
      });

      return;
    }

    // CASE C — Reveal a random tile
    const hidden = squares
      .map((_, i) => i)
      .filter((i) => {
        if (!userHasGuessed && i === PROTECTED_TILE_INDEX) return false;
        return !revealedIndices.has(i);
      });

    if (hidden.length > 0) {
      const randomIdx = hidden[Math.floor(Math.random() * hidden.length)];
      revealedIndices.add(randomIdx);
      squares[randomIdx].classList.add("revealed");
    }

    // CASE D — Fallback: no tiles remaining
    const remainingAfterReveal = squares
      .map((_, i) => i)
      .filter((i) => !revealedIndices.has(i));

    if (remainingAfterReveal.length === 0) {
      console.log("[LM] CASE D triggered — no tiles remaining");
      clearInterval(gameLoopId);
      gameActive = false;

      if (!revealedIndices.has(PROTECTED_TILE_INDEX)) {
        revealedIndices.add(PROTECTED_TILE_INDEX);
        squares[PROTECTED_TILE_INDEX].classList.add("revealed");
      }

      const correctBtn = btnContainer.querySelector(`button[data-id="${CORRECT_ANSWER}"]`);
      if (correctBtn) {
        correctBtn.classList.add("selected-correct", "correct-answer-hint", "correct-final");
      }

      if (!userHasGuessed) {
        computeUserTagAndPoints(false, revealedIndices.size);
      }

      buildFinalUrl();
      renderAnswerDetails();

      // Fire Klaviyo event ONCE
      fireKlaviyoEvent(buildKlaviyoPayload(false));
    }

  }, REVEAL_DELAY);
}

<!-- BLOCK C1 End (core game + grid + TAG + reveal engine) -->


<!-- BLOCK C2 (guess handling + event firing) -->

function markButtonsAfterGuess(choice, isCorrect) {
  console.log("[LM] markButtonsAfterGuess() called", { choice, isCorrect });
  const buttons = btnContainer.querySelectorAll("button");

  buttons.forEach((btn) => {
    const id = btn.dataset.id;
    btn.disabled = true;

    if (id === choice) {
      btn.classList.add(isCorrect ? "selected-correct" : "selected-wrong");
      console.log("[LM] Button marked after guess:", { id, isCorrect });
    }
  });
}

function handleGuess(choice) {
  console.log("[LM] handleGuess() called — choice:", choice);

  status.innerText = "";
  if (!gameActive || userHasGuessed) {
    console.log("[LM] handleGuess() aborted — gameActive/userHasGuessed", { gameActive, userHasGuessed });
    return;
  }

  userHasGuessed = true;
  console.log("[LM] userHasGuessed set to true");

  const isCorrect = choice === CORRECT_ANSWER;
  tileIndexAtGuess = revealedIndices.size;

  console.log("[LM] Guess evaluated:", { isCorrect, tileIndexAtGuess });

  // Mark buttons
  markButtonsAfterGuess(choice, isCorrect);

  // Tag + URL logic
  computeUserTagAndPoints(isCorrect, tileIndexAtGuess);
  buildFinalUrl();

  if (isCorrect) {
    // ✅ Correct: stop loop, reveal everything now
    console.log("[LM] Correct guess — stopping loop and revealing all tiles");
    clearInterval(gameLoopId);

    const correctBtn = btnContainer.querySelector(`button[data-id="${CORRECT_ANSWER}"]`);
    if (correctBtn) {
      correctBtn.classList.add("selected-correct");
      correctBtn.classList.add("correct-answer-hint");
      correctBtn.classList.add("correct-final");
      console.log("[LM] Correct button final classes applied in handleGuess");
    } else {
      console.log("[LM] No correct button found in handleGuess (correct branch)");
    }

    // Mark wrong buttons for final state
    [...btnContainer.querySelectorAll("button")].forEach(b => {
      if (b.dataset.id !== CORRECT_ANSWER) {
        b.classList.add("wrong-final");
        console.log("[LM] Wrong button marked wrong-final:", b.dataset.id);
      }
    });

    // Reveal all tiles, including protected
    revealAllTiles();
    if (!revealedIndices.has(PROTECTED_TILE_INDEX)) {
      revealedIndices.add(PROTECTED_TILE_INDEX);
      squares[PROTECTED_TILE_INDEX].classList.add("revealed");
      console.log("[LM] Protected tile revealed in handleGuess (correct branch):", PROTECTED_TILE_INDEX);
    }

    // Final UI
    renderAnswerDetails();
    //fireKlaviyoEvent(buildKlaviyoPayload(true));
    klaviyoReady(() => {
      fireKlaviyoEvent(buildKlaviyoPayload(true));
    });



  } else {
    // ❌ Incorrect: DO NOT reveal all tiles now
    console.log("[LM] Incorrect guess — leaving loop running");
    status.innerText = "Not quite — come back tomorrow for a new reveal.";
    status.style.color = "#99182D";

    const wrongBtn = btnContainer.querySelector(`button[data-id="${choice}"]`);
    if (wrongBtn) {
      wrongBtn.classList.add("selected-wrong");
      console.log("[LM] Wrong button marked selected-wrong:", choice);
    } else {
      console.log("[LM] No wrong button found in handleGuess (incorrect branch)");
    }
  }
}

function getPacificDateTime() {
  console.log("[LM] getPacificDateTime() called");
  const now = new Date();
  const pst = new Date(now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
  const result = pst.toISOString().replace("T", " ").slice(0, 19);
  console.log("[LM] getPacificDateTime() result:", result);
  return result;
}

<!-- BLOCK C2 End (guess handling + event firing) -->


<!-- BLOCK C3  v2 (Klaviyo orchestration + share + init + (ATLAS-COMPATIBLE)) -->
 

<!-- BLOCK C3  v2 (cleaned: share + init only, no Klaviyo) -->
/* ---------------------------------------------------------
   LUXMYX — Final Architecture with Debug Logging (CLEANED)
   --------------------------------------------------------- */

console.log("[LM] Script loaded (game init + share)");

/* ---------------------------------------------------------
   SHARE + GAME INITIALIZATION ONLY (Klaviyo removed)
   --------------------------------------------------------- */

function getShareUrl() {
  console.log("[LM] getShareUrl() called");
  const override = window.GAME_SHARE_CONFIG.urlOverride;
  console.log("[LM] GAME_SHARE_CONFIG.urlOverride:", override);

  if (
    override &&
    override !== "null" &&
    override !== "undefined" &&
    override.trim() !== ""
  ) {
    console.log("[LM] Using override share URL");
    return override;
  }

  const fallback = window.location.origin + "/RevealGame";
  console.log("[LM] Using fallback share URL:", fallback);
  return fallback;
}

if (shareButton) {
  console.log("[LM] shareButton found — attaching click handler");
  shareButton.addEventListener("click", () => {
    console.log("[LM] shareButton clicked");
    const shareConfig = window.GAME_SHARE_CONFIG || {};
    const url = getShareUrl();
    const title = shareConfig.title || "Trust your intuition—select a response below.";
    const description = shareConfig.description || "Can you guess the handbag brand and style before the tiles disappear?";
    const text = `${title}\n\n${description}\n`;

    const image = shareConfig.thumbnail || RIGHT_ANSWER_DETAILS.image;

    console.log("[LM] Share config resolved:", { url, title, description, image });

    // Mobile share sheet
    if (navigator.share) {
      console.log("[LM] Using navigator.share");
      navigator.share({
        title,
        text,
        url
      }).catch((err) => {
        console.log("[LM] navigator.share error:", err);
      });
      return;
    }

    // Desktop fallback
    const links = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`,
      pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(image)}&description=${encodeURIComponent(text)}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      reddit: `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,
      email: `mailto:?subject=${encodeURIComponent(title)}&body=${
        encodeURIComponent(
          description + "\n\n" + url + "\n" + "\u00A0" + "\n"
        )
      }`,
      sms: `sms:?body=${encodeURIComponent(text + " " + url)}`,
      copy: url
    };

    console.log("[LM] Desktop share links generated:", links);

    openShareMenu(links);
  });
} else {
  console.log("[LM] shareButton NOT found — share disabled");
}

function openShareMenu(links) {
  console.log("[LM] openShareMenu() called");
  const menu = document.createElement("div");
  menu.className = "luxmyx-share-menu";

  menu.innerHTML = `
    <div class="share-options">
      <a href="${links.facebook}" target="_blank">Facebook</a>
      <a href="${links.pinterest}" target="_blank">Pinterest</a>
      <a href="${links.twitter}" target="_blank">X (Twitter)</a>
      <a href="${links.linkedin}" target="_blank">LinkedIn</a>
      <a href="${links.reddit}" target="_blank">Reddit</a>
      <a href="${links.email}">Email</a>
      <a href="${links.sms}">SMS</a>
      <button class="copy-link">Copy Link</button>
    </div>
  `;

  document.body.appendChild(menu);
  console.log("[LM] Share menu appended to body");

  menu.querySelector(".copy-link").onclick = () => {
    console.log("[LM] Copy link clicked");
    navigator.clipboard.writeText(links.copy)
      .then(() => console.log("[LM] Link copied to clipboard"))
      .catch(err => console.log("[LM] Clipboard write error:", err));
  };

  // Auto-close on click outside
  menu.addEventListener("click", (e) => {
    if (e.target === menu) {
      console.log("[LM] Click outside share menu — removing");
      menu.remove();
    }
  });
}

/*<!--
 function buildKlaviyoPayload(isCorrect) {
  const pst = new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
  );

  return {
    "LM-GameDate": pst.toISOString().slice(0, 10),
    "LM-GameDateTime": pst.toISOString().replace("T", " ").slice(0, 19),
    "LM-DayOfWeek": pst.toLocaleString("en-US", { weekday: "long" }),
    "LM-CorrectAnswer": RIGHT_ANSWER_DETAILS.title,
    "LM-GuessedCorrectly": isCorrect,
    "LM-TileIndexAtGuess": tileIndexAtGuess,
    "LM-Tag": userTag,
    "LM-Points": rewardPoints,
    "LM-URL": window.location.href,
    "LM-Explore": RIGHT_ANSWER_DETAILS.baseUrl || ""
  };
 } -->*/

/* ---------------------------------------------------------
   Debounced Resize Handler (prevents infinite setupGrid loop)
   --------------------------------------------------------- */
let resizeTimeout = null;

function resizeHandler() {
  if (resizeTimeout) clearTimeout(resizeTimeout);

  resizeTimeout = setTimeout(() => {
    console.log("[LM] window resize (debounced) — calling setupGrid()");
    setupGrid();
  }, 200);
}

window.addEventListener("resize", resizeHandler);

/* ---------------------------------------------------------
   INITIALIZATION
   --------------------------------------------------------- */
console.log("[LM] Calling renderButtons(), setupGrid(), and starting game loop with delay");
renderButtons();
setupGrid();

status.innerText = "Trust your intuition—select a response below";
console.log("[LM] Initial status message set");

setTimeout(() => {
  console.log("[LM] Starting game loop after initial delay");
  startGameLoop();
}, 3000);


})();

  } catch(e) { console.error(e); }
})();
})();
